var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"if-content"},[_c('iframe',{attrs:{"src":_vm.url,"allow":"","height":"100%","width":"100%","loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }